// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Sora:wght@400;500;600;700;800&family=Outfit:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Dashboard2 redesign styles */

.dashboard-container.dashboard-redesign {
  min-height: 100vh;
  background:
    radial-gradient(1000px 600px at 10% 0%, rgba(114, 71, 255, 0.2), transparent 55%),
    radial-gradient(900px 500px at 90% 10%, rgba(0, 196, 255, 0.16), transparent 55%),
    #070b16;
  color: #eef3ff;
  position: relative;
  overflow-x: hidden;
  font-family: 'Outfit', sans-serif;
}

.dashboard-container.dashboard-redesign,
.dashboard-container.dashboard-redesign *,
.dashboard-container.dashboard-redesign *::before,
.dashboard-container.dashboard-redesign *::after {
  box-sizing: border-box;
}

.dashboard-container.dashboard-redesign .dashboard-inner {
  width: min(1260px, calc(100vw - 32px));
  margin: 0 auto;
  padding: 20px;
  position: relative;
  z-index: 1;
}

.dashboard-container.dashboard-redesign .animated-bg {
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: 0;
  overflow: hidden;
}

.dashboard-container.dashboard-redesign .gradient-orb {
  position: absolute;
  border-radius: 999px;
  filter: blur(95px);
  opacity: 0.52;
  animation: dash2-float 16s ease-in-out infinite;
}

.dashboard-container.dashboard-redesign .orb-1 {
  width: 460px;
  height: 460px;
  right: -140px;
  top: -120px;
  background: radial-gradient(circle, rgba(125, 92, 255, 0.85), rgba(125, 92, 255, 0.12));
}

.dashboard-container.dashboard-redesign .orb-2 {
  width: 380px;
  height: 380px;
  left: -120px;
  bottom: 4%;
  animation-delay: 4s;
  background: radial-gradient(circle, rgba(255, 81, 143, 0.8), rgba(255, 81, 143, 0.08));
}

.dashboard-container.dashboard-redesign .orb-3 {
  width: 280px;
  height: 280px;
  right: 16%;
  bottom: 34%;
  animation-delay: 8s;
  background: radial-gradient(circle, rgba(0, 214, 255, 0.8), rgba(0, 214, 255, 0.08));
}

@keyframes dash2-float {
  0%,
  100% {
    transform: translate3d(0, 0, 0) scale(1);
  }
  50% {
    transform: translate3d(18px, -14px, 0) scale(1.08);
  }
}

.dashboard-container.dashboard-redesign .dashboard-content {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  max-width: none;
  margin: 0;
  padding: 0;
  gap: 24px;
}

.dashboard-container.dashboard-redesign .hero-section {
  margin-top: 8px;
}

.dashboard-container.dashboard-redesign .hero-glass-card {
  border-radius: 28px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  background: linear-gradient(150deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.02));
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.5);
  padding: 34px;
}

.dashboard-container.dashboard-redesign .hero-badge {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
}

.dashboard-container.dashboard-redesign .live-badge {
  background: linear-gradient(140deg, #ff3f78, #ff7d43);
  color: #fff;
  padding: 5px 12px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.dashboard-container.dashboard-redesign .players-count {
  color: #b6c2ea;
  font-size: 13px;
}

.dashboard-container.dashboard-redesign .featured-game-switcher {
  display: flex;
  gap: 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  padding-bottom: 18px;
  margin-bottom: 26px;
}

.dashboard-container.dashboard-redesign .featured-tab {
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.05);
  color: #d6ddf7;
  border-radius: 999px;
  padding: 10px 18px;
  font-weight: 700;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: 0.2s ease;
}

.dashboard-container.dashboard-redesign .featured-tab:hover {
  transform: translateY(-1px);
  background: rgba(255, 255, 255, 0.1);
}

.dashboard-container.dashboard-redesign .featured-tab.active {
  background: linear-gradient(140deg, #7e63ff, #4f93ff);
  color: #fff;
  border-color: transparent;
  box-shadow: 0 14px 28px rgba(79, 147, 255, 0.35);
}

.dashboard-container.dashboard-redesign .featured-game-content {
  display: block;
}

.dashboard-container.dashboard-redesign .featured-slide {
  position: relative;
  min-height: 360px;
  border-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.16);
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  overflow: hidden;
  padding: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: dash2-slide-in 360ms ease;
}

.dashboard-container.dashboard-redesign .featured-home-copy {
  display: none;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 3;
  width: min(760px, calc(100% - 56px));
  padding: clamp(14px, 2.2vw, 20px) clamp(16px, 2.4vw, 24px);
  border-radius: 18px;
  border: 1px solid rgba(255, 255, 255, 0.42);
  background: rgba(255, 255, 255, 0.2);
  box-shadow: 0 12px 28px rgba(4, 22, 47, 0.22);
  text-align: center;
}

.dashboard-container.dashboard-redesign .featured-home-intro {
  margin: 0;
  color: #f8fcff;
  font-family: 'Sora', sans-serif;
  font-size: clamp(1.2rem, 3.2vw, 2.2rem);
  font-weight: 900;
  line-height: 1.1;
  letter-spacing: 0.01em;
  text-shadow: 0 2px 10px rgba(4, 16, 33, 0.55);
}

.dashboard-container.dashboard-redesign .featured-home-brand {
  margin: 6px 0 0;
  font-family: 'Sora', sans-serif;
  font-size: clamp(1.7rem, 4.8vw, 3.3rem);
  font-weight: 900;
  line-height: 1;
  letter-spacing: 0.01em;
  background: linear-gradient(135deg, #0c2240 0%, #0b4a86 48%, #118acb 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.dashboard-container.dashboard-redesign .featured-home-caption {
  margin: 10px 0 0;
  color: #eaf6ff;
  font-size: clamp(0.92rem, 2.1vw, 1.18rem);
  font-weight: 700;
  letter-spacing: 0.01em;
  text-shadow: 0 2px 10px rgba(4, 16, 33, 0.5);
}

@keyframes dash2-slide-in {
  from {
    opacity: 0.5;
    transform: scale(0.985);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.dashboard-container.dashboard-redesign .featured-cta-wrap {
  position: absolute;
  left: 50%;
  bottom: 30px;
  transform: translateX(-50%);
  z-index: 3;
}

@media (min-width: 1400px) {
  .dashboard-container.dashboard-redesign .featured-slide {
    min-height: 460px;
    background-size: auto 100%;
    background-repeat: repeat-x;
    background-position: center;
    background-color: #050a17;
  }

  .dashboard-container.dashboard-redesign .featured-cta-wrap {
    bottom: 34px;
  }
}

.dashboard-container.dashboard-redesign .featured-carousel-controls {
  position: absolute;
  right: 20px;
  bottom: 18px;
  z-index: 2;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.dashboard-container.dashboard-redesign .carousel-arrow {
  width: 34px;
  height: 34px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.25);
  background: rgba(8, 13, 28, 0.56);
  color: #fff;
  font-size: 19px;
  line-height: 1;
  cursor: pointer;
}

.dashboard-container.dashboard-redesign .carousel-dots {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 0 2px;
}

.dashboard-container.dashboard-redesign .carousel-dot {
  width: 9px;
  height: 9px;
  border-radius: 999px;
  border: none;
  padding: 0;
  background: rgba(255, 255, 255, 0.4);
  cursor: pointer;
  transition: transform 0.2s ease, background-color 0.2s ease;
}

.dashboard-container.dashboard-redesign .carousel-dot.active {
  width: 24px;
  background: #68deff;
}

.dashboard-container.dashboard-redesign .featured-slide-labels {
  position: absolute;
  left: 20px;
  bottom: 18px;
  z-index: 2;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.dashboard-container.dashboard-redesign .slide-label {
  border: 1px solid rgba(255, 255, 255, 0.24);
  border-radius: 999px;
  background: rgba(8, 13, 28, 0.45);
  color: #c8d3f3;
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  cursor: pointer;
}

.dashboard-container.dashboard-redesign .slide-label.active {
  color: #07162f;
  background: #68deff;
  border-color: #68deff;
}

.dashboard-container.dashboard-redesign .game-icon-large {
  font-size: 52px;
  line-height: 1;
}

.dashboard-container.dashboard-redesign .game-title {
  margin: 12px 0 0;
  font-family: 'Sora', sans-serif;
  font-size: clamp(2rem, 4vw, 2.8rem);
  line-height: 1.05;
}

.dashboard-container.dashboard-redesign .game-subtitle {
  margin: 8px 0 14px;
  color: #a6b5e4;
  font-size: 1rem;
  letter-spacing: 0.02em;
}

.dashboard-container.dashboard-redesign .game-description {
  margin: 0;
  color: #d8e1ff;
  max-width: 66ch;
}

.dashboard-container.dashboard-redesign .game-stats {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  margin: 20px 0 24px;
}

.dashboard-container.dashboard-redesign .game-stats .stat-item {
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.04);
  border-radius: 12px;
  padding: 10px 12px;
}

.dashboard-container.dashboard-redesign .game-stats .stat-label {
  display: block;
  font-size: 11px;
  color: #93a5dd;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.dashboard-container.dashboard-redesign .game-stats .stat-value {
  display: block;
  margin-top: 6px;
  font-size: 15px;
  font-weight: 800;
  color: #fff;
}

.dashboard-container.dashboard-redesign .btn-play-now {
  border: none;
  background: linear-gradient(140deg, #00ccff, #4f93ff);
  color: #04162f;
  font-weight: 800;
  border-radius: 14px;
  padding: 12px 20px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  transition: 0.2s ease;
}

.dashboard-container.dashboard-redesign .btn-play-now:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 26px rgba(0, 204, 255, 0.36);
}

.dashboard-container.dashboard-redesign .game-visual {
  min-height: 250px;
  border-radius: 22px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: linear-gradient(150deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.04));
  position: relative;
  display: grid;
  place-items: center;
  overflow: hidden;
}

.dashboard-container.dashboard-redesign .visual-effect {
  position: absolute;
  inset: -20%;
  background: conic-gradient(from 180deg, rgba(255, 255, 255, 0.12), transparent 36%, rgba(255, 255, 255, 0.15), transparent 70%);
  animation: dash2-spin 9s linear infinite;
}

@keyframes dash2-spin {
  to {
    transform: rotate(360deg);
  }
}

.dashboard-container.dashboard-redesign .card-stack {
  position: relative;
  z-index: 1;
}

.dashboard-container.dashboard-redesign .whot-card {
  width: 74px;
  height: 98px;
  border-radius: 12px;
  background: #fff;
  color: #101623;
  display: grid;
  place-items: center;
  font-size: 34px;
  position: absolute;
  top: 0;
  left: 0;
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.35);
}

.dashboard-container.dashboard-redesign .card-1 { transform: rotate(-14deg) translate(-36px, 18px); }
.dashboard-container.dashboard-redesign .card-2 { transform: rotate(0deg); }
.dashboard-container.dashboard-redesign .card-3 { transform: rotate(14deg) translate(36px, 18px); }

.dashboard-container.dashboard-redesign .chess-board-preview {
  display: flex;
  gap: 16px;
}

.dashboard-container.dashboard-redesign .chess-piece {
  width: 62px;
  height: 62px;
  border-radius: 16px;
  display: grid;
  place-items: center;
  font-size: 38px;
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.dashboard-container.dashboard-redesign .flappy-preview .bird {
  font-size: 48px;
  text-align: center;
  margin-bottom: 16px;
}

.dashboard-container.dashboard-redesign .pipes {
  display: flex;
  gap: 22px;
}

.dashboard-container.dashboard-redesign .pipe {
  width: 20px;
  height: 96px;
  border-radius: 999px;
  background: linear-gradient(180deg, #4fffc6, #13be8e);
}

.dashboard-container.dashboard-redesign .stats-bar {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}

.dashboard-container.dashboard-redesign .stat-card {
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
  padding: 12px 14px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.dashboard-container.dashboard-redesign .stat-icon {
  font-size: 20px;
}

.dashboard-container.dashboard-redesign .stat-info {
  display: grid;
  gap: 2px;
}

.dashboard-container.dashboard-redesign .stat-info .stat-label {
  font-size: 12px;
  color: #9eb0e8;
}

.dashboard-container.dashboard-redesign .stat-info .stat-value {
  font-size: 15px;
  font-weight: 700;
  color: #fff;
}

.dashboard-container.dashboard-redesign .game-modes-section,
.dashboard-container.dashboard-redesign .daily-section,
.dashboard-container.dashboard-redesign .quick-links-section,
.dashboard-container.dashboard-redesign .matchmaking-section,
.dashboard-container.dashboard-redesign .guest-section,
.dashboard-container.dashboard-redesign .referral-section,
.dashboard-container.dashboard-redesign .support-section {
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 22px;
  background: rgba(10, 15, 30, 0.75);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  padding: 24px;
}

.dashboard-container.dashboard-redesign .section-header {
  margin-bottom: 14px;
}

.dashboard-container.dashboard-redesign .section-title {
  margin: 0;
  font-family: 'Sora', sans-serif;
  font-size: clamp(1.25rem, 2.5vw, 1.7rem);
}

.dashboard-container.dashboard-redesign .section-subtitle {
  margin: 6px 0 0;
  color: #a5b3df;
}

.dashboard-container.dashboard-redesign .game-modes-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 12px;
}

.dashboard-container.dashboard-redesign .game-mode-card {
  position: relative;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.05);
  color: #eff3ff;
  text-align: left;
  padding: 14px;
  cursor: pointer;
  transition: 0.2s ease;
}

.dashboard-container.dashboard-redesign .game-mode-card:hover {
  transform: translateY(-2px);
  border-color: rgba(79, 147, 255, 0.75);
}

.dashboard-container.dashboard-redesign .featured-mode {
  border-color: rgba(160, 124, 255, 0.7);
  background: linear-gradient(160deg, rgba(126, 99, 255, 0.2), rgba(255, 255, 255, 0.05));
}

.dashboard-container.dashboard-redesign .mode-icon-wrapper {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  display: grid;
  place-items: center;
  margin-bottom: 10px;
  background: linear-gradient(135deg, #38456f, #29355c);
}

.dashboard-container.dashboard-redesign .from-purple-500.to-pink-500 { background: linear-gradient(135deg, #8c56ff, #ff5ec8); }
.dashboard-container.dashboard-redesign .from-red-500.to-orange-500 { background: linear-gradient(135deg, #ff4f61, #ff8a42); }
.dashboard-container.dashboard-redesign .from-green-500.to-teal-500 { background: linear-gradient(135deg, #10c67b, #00b3aa); }
.dashboard-container.dashboard-redesign .from-blue-500.to-cyan-500 { background: linear-gradient(135deg, #4f93ff, #00ccff); }
.dashboard-container.dashboard-redesign .from-yellow-500.to-red-500 { background: linear-gradient(135deg, #ffd24f, #ff6c50); }

.dashboard-container.dashboard-redesign .mode-title {
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
}

.dashboard-container.dashboard-redesign .mode-description {
  margin: 6px 0 0;
  color: #a9b7e2;
  font-size: 0.9rem;
}

.dashboard-container.dashboard-redesign .mode-play-btn {
  margin-top: 10px;
  font-size: 0.85rem;
  color: #75d9ff;
  font-weight: 700;
}

.dashboard-container.dashboard-redesign .mode-badge {
  position: absolute;
  top: 10px;
  right: 10px;
  min-width: 26px;
  height: 22px;
  padding: 0 8px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 800;
  display: grid;
  place-items: center;
}

.dashboard-container.dashboard-redesign .hot-badge {
  background: #ff4d73;
  color: #fff;
}

.dashboard-container.dashboard-redesign .pending-badge {
  background: #00d2ff;
  color: #04213b;
}

.dashboard-container.dashboard-redesign .daily-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.dashboard-container.dashboard-redesign .daily-card {
  border-radius: 14px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.05);
  padding: 14px;
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 10px;
  align-items: center;
}

.dashboard-container.dashboard-redesign .daily-icon {
  font-size: 24px;
}

.dashboard-container.dashboard-redesign .daily-game {
  margin: 0;
  font-size: 1rem;
}

.dashboard-container.dashboard-redesign .daily-challenge {
  margin: 4px 0 0;
  color: #9fb0e3;
  font-size: 0.9rem;
}

.dashboard-container.dashboard-redesign .daily-reward {
  border-radius: 999px;
  background: rgba(0, 210, 255, 0.16);
  border: 1px solid rgba(0, 210, 255, 0.45);
  color: #9cecff;
  padding: 6px 10px;
  font-weight: 700;
  font-size: 0.85rem;
}

.dashboard-container.dashboard-redesign .daily-card.coming-soon .daily-reward {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.22);
  color: #d8e1ff;
}

.dashboard-container.dashboard-redesign .daily-card--referral {
  border-color: rgba(0, 210, 120, 0.35);
  background: rgba(0, 210, 120, 0.07);
}

.dashboard-container.dashboard-redesign .daily-card--referral .daily-reward {
  background: rgba(0, 210, 120, 0.18);
  border-color: rgba(0, 210, 120, 0.55);
  color: #7dffc7;
}

.dashboard-container.dashboard-redesign .daily-referral-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  flex-wrap: wrap;
}

.dashboard-container.dashboard-redesign .daily-ref-code {
  font-family: monospace;
  font-size: 0.82rem;
  color: #7dffc7;
  background: rgba(0, 210, 120, 0.12);
  border: 1px solid rgba(0, 210, 120, 0.3);
  border-radius: 6px;
  padding: 2px 8px;
  letter-spacing: 1px;
}

.dashboard-container.dashboard-redesign .daily-ref-copy {
  background: rgba(0, 210, 120, 0.2);
  border: 1px solid rgba(0, 210, 120, 0.5);
  color: #7dffc7;
  border-radius: 6px;
  padding: 3px 12px;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}

.dashboard-container.dashboard-redesign .daily-ref-copy:hover {
  background: rgba(0, 210, 120, 0.35);
}

.dashboard-container.dashboard-redesign .quick-links-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 12px;
}

.dashboard-container.dashboard-redesign .quick-link-card {
  border-radius: 14px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.05);
  color: #fff;
  text-align: left;
  padding: 14px;
  cursor: pointer;
  transition: 0.2s ease;
}

.dashboard-container.dashboard-redesign .quick-link-card:hover {
  transform: translateY(-2px);
  border-color: rgba(79, 147, 255, 0.7);
}

.dashboard-container.dashboard-redesign .quick-icon {
  display: block;
  font-size: 20px;
  margin-bottom: 6px;
}

.dashboard-container.dashboard-redesign .quick-label {
  display: block;
  font-weight: 700;
}

.dashboard-container.dashboard-redesign .quick-desc {
  display: block;
  margin-top: 3px;
  font-size: 0.85rem;
  color: #a2b2df;
}

.dashboard-container.dashboard-redesign .active-challenge-card {
  border-radius: 14px;
  border: 1px solid rgba(0, 210, 255, 0.38);
  background: rgba(0, 210, 255, 0.1);
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
}

.dashboard-container.dashboard-redesign .active-challenge-card--whot {
  border-color: rgba(250, 204, 21, 0.42);
  background:
    linear-gradient(135deg, rgba(250, 204, 21, 0.14), rgba(245, 158, 11, 0.08)),
    rgba(255, 255, 255, 0.06);
}

.dashboard-container.dashboard-redesign .challenge-info {
  display: grid;
  gap: 3px;
}

.dashboard-container.dashboard-redesign .challenge-info span {
  color: #bed0ff;
  font-size: 0.9rem;
}

.dashboard-container.dashboard-redesign .btn-resume,
.dashboard-container.dashboard-redesign .btn-find-match,
.dashboard-container.dashboard-redesign .btn-leave-queue,
.dashboard-container.dashboard-redesign .btn-guest,
.dashboard-container.dashboard-redesign .btn-login,
.dashboard-container.dashboard-redesign .btn-copy,
.dashboard-container.dashboard-redesign .btn-share {
  border: none;
  border-radius: 12px;
  padding: 10px 14px;
  font-weight: 700;
  cursor: pointer;
  transition: 0.2s ease;
}

.dashboard-container.dashboard-redesign .btn-resume,
.dashboard-container.dashboard-redesign .btn-find-match,
.dashboard-container.dashboard-redesign .btn-guest,
.dashboard-container.dashboard-redesign .btn-copy {
  background: linear-gradient(140deg, #4f93ff, #00ccff);
  color: #061d3a;
}

.dashboard-container.dashboard-redesign .btn-leave-queue {
  background: linear-gradient(140deg, #ff5d79, #ff7a50);
  color: #fff;
}

.dashboard-container.dashboard-redesign .btn-login,
.dashboard-container.dashboard-redesign .btn-share {
  background: rgba(255, 255, 255, 0.12);
  color: #eef3ff;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.dashboard-container.dashboard-redesign .btn-resume:hover,
.dashboard-container.dashboard-redesign .btn-find-match:hover,
.dashboard-container.dashboard-redesign .btn-leave-queue:hover,
.dashboard-container.dashboard-redesign .btn-guest:hover,
.dashboard-container.dashboard-redesign .btn-login:hover,
.dashboard-container.dashboard-redesign .btn-copy:hover,
.dashboard-container.dashboard-redesign .btn-share:hover {
  transform: translateY(-1px);
}

.dashboard-container.dashboard-redesign .error-message,
.dashboard-container.dashboard-redesign .queue-status,
.dashboard-container.dashboard-redesign .referral-feedback {
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 0.92rem;
  margin-bottom: 10px;
}

.dashboard-container.dashboard-redesign .error-message {
  background: rgba(255, 87, 120, 0.14);
  border: 1px solid rgba(255, 87, 120, 0.45);
  color: #ffc3d0;
}

.dashboard-container.dashboard-redesign .queue-status,
.dashboard-container.dashboard-redesign .referral-feedback {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.14);
  color: #d9e5ff;
}

.dashboard-container.dashboard-redesign .matchmaking-controls {
  display: grid;
  gap: 12px;
}

.dashboard-container.dashboard-redesign .wager-label,
.dashboard-container.dashboard-redesign .balance-hint {
  color: #a6b5e4;
}

.dashboard-container.dashboard-redesign .wager-value-display {
  margin: 6px 0;
  font-size: 1.5rem;
  font-weight: 800;
}

.dashboard-container.dashboard-redesign .wager-slider {
  width: 100%;
}

.dashboard-container.dashboard-redesign .guest-card {
  border-radius: 14px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  background: rgba(255, 255, 255, 0.05);
  padding: 18px;
}

.dashboard-container.dashboard-redesign .guest-card h3 {
  margin: 0;
}

.dashboard-container.dashboard-redesign .guest-card p {
  margin: 8px 0 14px;
  color: #afbee9;
}

.dashboard-container.dashboard-redesign .guest-buttons {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.dashboard-container.dashboard-redesign .referral-content {
  display: grid;
  grid-template-columns: 0.9fr 1.1fr;
  gap: 12px;
}

.dashboard-container.dashboard-redesign .referral-code-card,
.dashboard-container.dashboard-redesign .referral-link-card {
  border-radius: 14px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  background: rgba(255, 255, 255, 0.05);
  padding: 14px;
  display: grid;
  gap: 8px;
}

.dashboard-container.dashboard-redesign .code-label,
.dashboard-container.dashboard-redesign .link-label {
  color: #9fb0e3;
  font-size: 0.85rem;
}

.dashboard-container.dashboard-redesign .code-value,
.dashboard-container.dashboard-redesign .link-value {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace;
  padding: 8px 10px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: rgba(255, 255, 255, 0.06);
  word-break: break-all;
}

.dashboard-container.dashboard-redesign .link-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.dashboard-container.dashboard-redesign .support-callout {
  border-radius: 14px;
  border: 1px solid rgba(0, 210, 255, 0.3);
  background: rgba(0, 210, 255, 0.09);
  color: #d9f7ff;
  padding: 12px 14px;
  margin-bottom: 14px;
}

.dashboard-container.dashboard-redesign .support-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.dashboard-container.dashboard-redesign .support-card {
  border-radius: 14px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  background: rgba(255, 255, 255, 0.05);
  padding: 16px;
  display: grid;
  gap: 8px;
  color: #eef3ff;
  text-decoration: none;
  transition: transform 0.2s ease, border-color 0.2s ease, background-color 0.2s ease;
}

.dashboard-container.dashboard-redesign .support-card:hover {
  transform: translateY(-2px);
  border-color: rgba(79, 147, 255, 0.75);
  background: rgba(255, 255, 255, 0.08);
}

.dashboard-container.dashboard-redesign .support-label {
  color: #9fb0e3;
  font-size: 0.85rem;
}

.dashboard-container.dashboard-redesign .support-value {
  font-size: 1rem;
  word-break: break-word;
}

.dashboard-container.dashboard-redesign .support-hint {
  color: #bfd0ff;
  font-size: 0.9rem;
  line-height: 1.45;
}

.dashboard-container.dashboard-redesign .menu-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(5, 8, 16, 0.65);
  z-index: 1000;
}

.dashboard-container.dashboard-redesign .profile-menu-modal {
  position: fixed;
  top: 84px;
  right: 24px;
  width: min(360px, calc(100vw - 30px));
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.16);
  background: rgba(10, 15, 30, 0.95);
  box-shadow: 0 26px 46px rgba(0, 0, 0, 0.55);
  padding: 16px;
  z-index: 1001;
}

.dashboard-container.dashboard-redesign .profile-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.dashboard-container.dashboard-redesign .profile-avatar {
  width: 42px;
  height: 42px;
  border-radius: 999px;
  display: grid;
  place-items: center;
  font-weight: 800;
  background: linear-gradient(140deg, #7e63ff, #00ccff);
  color: #061d3a;
}

.dashboard-container.dashboard-redesign .profile-name {
  margin: 0;
}

.dashboard-container.dashboard-redesign .profile-stats {
  display: grid;
  gap: 8px;
}

.dashboard-container.dashboard-redesign .profile-stat {
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.05);
  padding: 9px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

@media (max-width: 1150px) {
  .dashboard-container.dashboard-redesign .featured-cta-wrap {
    bottom: 44px;
  }

  .dashboard-container.dashboard-redesign .stats-bar,
  .dashboard-container.dashboard-redesign .game-modes-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .dashboard-container.dashboard-redesign .daily-grid,
  .dashboard-container.dashboard-redesign .quick-links-grid,
  .dashboard-container.dashboard-redesign .referral-content,
  .dashboard-container.dashboard-redesign .support-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 760px) {
  .dashboard-container.dashboard-redesign .dashboard-inner {
    width: calc(100vw - 12px);
    max-width: calc(100vw - 12px);
    margin: 0 auto;
    padding: 14px 12px 16px;
  }

  .dashboard-container.dashboard-redesign .dashboard-content {
    width: 100%;
    min-width: 0;
    justify-items: stretch;
    gap: 18px;
  }

  .dashboard-container.dashboard-redesign .dashboard-content > * {
    width: 100%;
    min-width: 0;
  }

  .dashboard-container.dashboard-redesign .hero-glass-card,
  .dashboard-container.dashboard-redesign .game-modes-section,
  .dashboard-container.dashboard-redesign .daily-section,
  .dashboard-container.dashboard-redesign .quick-links-section,
  .dashboard-container.dashboard-redesign .matchmaking-section,
  .dashboard-container.dashboard-redesign .guest-section,
  .dashboard-container.dashboard-redesign .referral-section,
  .dashboard-container.dashboard-redesign .support-section {
    padding: 16px;
    border-radius: 16px;
  }

  .dashboard-container.dashboard-redesign .featured-slide {
    min-height: 430px;
    padding: 20px;
  }

  .dashboard-container.dashboard-redesign .featured-home-copy {
    display: block;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: calc(100% - 40px);
    padding: 13px 12px;
    border-radius: 14px;
  }

  .dashboard-container.dashboard-redesign .featured-cta-wrap {
    bottom: 72px;
  }

  .dashboard-container.dashboard-redesign .featured-slide-labels {
    left: 14px;
    bottom: 14px;
    gap: 6px;
  }

  .dashboard-container.dashboard-redesign .slide-label {
    padding: 5px 10px;
    font-size: 11px;
  }

  .dashboard-container.dashboard-redesign .featured-carousel-controls {
    right: 14px;
    bottom: 14px;
  }

  .dashboard-container.dashboard-redesign .game-stats {
    grid-template-columns: 1fr;
  }

  .dashboard-container.dashboard-redesign .stats-bar,
  .dashboard-container.dashboard-redesign .game-modes-grid {
    grid-template-columns: 1fr;
  }

  .dashboard-container.dashboard-redesign .daily-card {
    grid-template-columns: auto 1fr;
  }

  .dashboard-container.dashboard-redesign .daily-reward {
    grid-column: span 2;
    justify-self: start;
  }

  .dashboard-container.dashboard-redesign .profile-menu-modal {
    right: 12px;
    left: 12px;
    width: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Dashboard2.css"],"names":[],"mappings":"AAAA,+BAA+B;;AAI/B;EACE,iBAAiB;EACjB;;;WAGS;EACT,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;;;;EAIE,sBAAsB;AACxB;;AAEA;EACE,sCAAsC;EACtC,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,oBAAoB;EACpB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,WAAW;EACX,uFAAuF;AACzF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,sFAAsF;AACxF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,oFAAoF;AACtF;;AAEA;EACE;;IAEE,wCAAwC;EAC1C;EACA;IACE,kDAAkD;EACpD;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,qCAAqC;EACrC,eAAe;EACf,SAAS;EACT,UAAU;EACV,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,yFAAyF;EACzF,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;EACrD,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kDAAkD;EAClD,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;EAC3C,qCAAqC;EACrC,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,qDAAqD;EACrD,WAAW;EACX,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;EAC3C,2BAA2B;EAC3B,sBAAsB;EACtB,4BAA4B;EAC5B,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,UAAU;EACV,oCAAoC;EACpC,0DAA0D;EAC1D,mBAAmB;EACnB,2CAA2C;EAC3C,oCAAoC;EACpC,6CAA6C;EAC7C,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,+BAA+B;EAC/B,uCAAuC;EACvC,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,uCAAuC;EACvC,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,0EAA0E;EAC1E,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yCAAyC;EACzC,gBAAgB;EAChB,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE;IACE,YAAY;IACZ,uBAAuB;EACzB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE;IACE,iBAAiB;IACjB,0BAA0B;IAC1B,2BAA2B;IAC3B,2BAA2B;IAC3B,yBAAyB;EAC3B;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,2CAA2C;EAC3C,iCAAiC;EACjC,WAAW;EACX,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,YAAY;EACZ,UAAU;EACV,oCAAoC;EACpC,eAAe;EACf,2DAA2D;AAC7D;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,2CAA2C;EAC3C,oBAAoB;EACpB,iCAAiC;EACjC,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;EAC3C,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,qDAAqD;EACrD,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;EAC3C,wFAAwF;EACxF,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,+HAA+H;EAC/H,wCAAwC;AAC1C;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,2CAA2C;AAC7C;;AAEA,kDAAkD,gDAAgD,EAAE;AACpG,kDAAkD,uBAAuB,EAAE;AAC3E,kDAAkD,8CAA8C,EAAE;;AAElG;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;;;;;;;EAOE,2CAA2C;EAC3C,mBAAmB;EACnB,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;EACnC,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;EACrC,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,uFAAuF;AACzF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,qDAAqD;AACvD;;AAEA,uEAAuE,qDAAqD,EAAE;AAC9H,sEAAsE,qDAAqD,EAAE;AAC7H,sEAAsE,qDAAqD,EAAE;AAC7H,qEAAqE,qDAAqD,EAAE;AAC5H,sEAAsE,qDAAqD,EAAE;;AAE7H;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;EACrC,aAAa;EACb,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,mCAAmC;EACnC,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;EACrC,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;EACzC,kCAAkC;EAClC,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC;;6BAE2B;AAC7B;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;;;;;;;EAOE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;;;;EAIE,qDAAqD;EACrD,cAAc;AAChB;;AAEA;EACE,qDAAqD;EACrD,WAAW;AACb;;AAEA;;EAEE,qCAAqC;EACrC,cAAc;EACd,0CAA0C;AAC5C;;AAEA;;;;;;;EAOE,2BAA2B;AAC7B;;AAEA;;;EAGE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;;EAEE,qCAAqC;EACrC,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;EACrC,aAAa;AACf;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;AACX;;AAEA;;EAEE,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;EACrC,aAAa;EACb,aAAa;EACb,QAAQ;AACV;;AAEA;;EAEE,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,+GAA+G;EAC/G,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,mCAAmC;EACnC,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;EACrC,aAAa;EACb,aAAa;EACb,QAAQ;EACR,cAAc;EACd,qBAAqB;EACrB,mFAAmF;AACrF;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;EACtC,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,qCAAqC;EACrC,mBAAmB;EACnB,2CAA2C;EAC3C,kCAAkC;EAClC,2CAA2C;EAC3C,aAAa;EACb,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,qDAAqD;EACrD,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;EACrC,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;;IAEE,gDAAgD;EAClD;;EAEA;;;;IAIE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,yBAAyB;IACzB,6BAA6B;IAC7B,cAAc;IACd,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;;;;;;;;IAQE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,cAAc;IACd,SAAS;IACT,QAAQ;IACR,gCAAgC;IAChC,wBAAwB;IACxB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,UAAU;IACV,WAAW;EACb;AACF","sourcesContent":["/* Dashboard2 redesign styles */\n\n@import url('https://fonts.googleapis.com/css2?family=Sora:wght@400;500;600;700;800&family=Outfit:wght@400;500;600;700&display=swap');\n\n.dashboard-container.dashboard-redesign {\n  min-height: 100vh;\n  background:\n    radial-gradient(1000px 600px at 10% 0%, rgba(114, 71, 255, 0.2), transparent 55%),\n    radial-gradient(900px 500px at 90% 10%, rgba(0, 196, 255, 0.16), transparent 55%),\n    #070b16;\n  color: #eef3ff;\n  position: relative;\n  overflow-x: hidden;\n  font-family: 'Outfit', sans-serif;\n}\n\n.dashboard-container.dashboard-redesign,\n.dashboard-container.dashboard-redesign *,\n.dashboard-container.dashboard-redesign *::before,\n.dashboard-container.dashboard-redesign *::after {\n  box-sizing: border-box;\n}\n\n.dashboard-container.dashboard-redesign .dashboard-inner {\n  width: min(1260px, calc(100vw - 32px));\n  margin: 0 auto;\n  padding: 20px;\n  position: relative;\n  z-index: 1;\n}\n\n.dashboard-container.dashboard-redesign .animated-bg {\n  position: fixed;\n  inset: 0;\n  pointer-events: none;\n  z-index: 0;\n  overflow: hidden;\n}\n\n.dashboard-container.dashboard-redesign .gradient-orb {\n  position: absolute;\n  border-radius: 999px;\n  filter: blur(95px);\n  opacity: 0.52;\n  animation: dash2-float 16s ease-in-out infinite;\n}\n\n.dashboard-container.dashboard-redesign .orb-1 {\n  width: 460px;\n  height: 460px;\n  right: -140px;\n  top: -120px;\n  background: radial-gradient(circle, rgba(125, 92, 255, 0.85), rgba(125, 92, 255, 0.12));\n}\n\n.dashboard-container.dashboard-redesign .orb-2 {\n  width: 380px;\n  height: 380px;\n  left: -120px;\n  bottom: 4%;\n  animation-delay: 4s;\n  background: radial-gradient(circle, rgba(255, 81, 143, 0.8), rgba(255, 81, 143, 0.08));\n}\n\n.dashboard-container.dashboard-redesign .orb-3 {\n  width: 280px;\n  height: 280px;\n  right: 16%;\n  bottom: 34%;\n  animation-delay: 8s;\n  background: radial-gradient(circle, rgba(0, 214, 255, 0.8), rgba(0, 214, 255, 0.08));\n}\n\n@keyframes dash2-float {\n  0%,\n  100% {\n    transform: translate3d(0, 0, 0) scale(1);\n  }\n  50% {\n    transform: translate3d(18px, -14px, 0) scale(1.08);\n  }\n}\n\n.dashboard-container.dashboard-redesign .dashboard-content {\n  position: relative;\n  z-index: 1;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  max-width: none;\n  margin: 0;\n  padding: 0;\n  gap: 24px;\n}\n\n.dashboard-container.dashboard-redesign .hero-section {\n  margin-top: 8px;\n}\n\n.dashboard-container.dashboard-redesign .hero-glass-card {\n  border-radius: 28px;\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  background: linear-gradient(150deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.02));\n  backdrop-filter: blur(14px);\n  -webkit-backdrop-filter: blur(14px);\n  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.5);\n  padding: 34px;\n}\n\n.dashboard-container.dashboard-redesign .hero-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 20px;\n}\n\n.dashboard-container.dashboard-redesign .live-badge {\n  background: linear-gradient(140deg, #ff3f78, #ff7d43);\n  color: #fff;\n  padding: 5px 12px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.dashboard-container.dashboard-redesign .players-count {\n  color: #b6c2ea;\n  font-size: 13px;\n}\n\n.dashboard-container.dashboard-redesign .featured-game-switcher {\n  display: flex;\n  gap: 12px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.12);\n  padding-bottom: 18px;\n  margin-bottom: 26px;\n}\n\n.dashboard-container.dashboard-redesign .featured-tab {\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  background: rgba(255, 255, 255, 0.05);\n  color: #d6ddf7;\n  border-radius: 999px;\n  padding: 10px 18px;\n  font-weight: 700;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  transition: 0.2s ease;\n}\n\n.dashboard-container.dashboard-redesign .featured-tab:hover {\n  transform: translateY(-1px);\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.dashboard-container.dashboard-redesign .featured-tab.active {\n  background: linear-gradient(140deg, #7e63ff, #4f93ff);\n  color: #fff;\n  border-color: transparent;\n  box-shadow: 0 14px 28px rgba(79, 147, 255, 0.35);\n}\n\n.dashboard-container.dashboard-redesign .featured-game-content {\n  display: block;\n}\n\n.dashboard-container.dashboard-redesign .featured-slide {\n  position: relative;\n  min-height: 360px;\n  border-radius: 24px;\n  border: 1px solid rgba(255, 255, 255, 0.16);\n  background-position: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  overflow: hidden;\n  padding: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  animation: dash2-slide-in 360ms ease;\n}\n\n.dashboard-container.dashboard-redesign .featured-home-copy {\n  display: none;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 3;\n  width: min(760px, calc(100% - 56px));\n  padding: clamp(14px, 2.2vw, 20px) clamp(16px, 2.4vw, 24px);\n  border-radius: 18px;\n  border: 1px solid rgba(255, 255, 255, 0.42);\n  background: rgba(255, 255, 255, 0.2);\n  box-shadow: 0 12px 28px rgba(4, 22, 47, 0.22);\n  text-align: center;\n}\n\n.dashboard-container.dashboard-redesign .featured-home-intro {\n  margin: 0;\n  color: #f8fcff;\n  font-family: 'Sora', sans-serif;\n  font-size: clamp(1.2rem, 3.2vw, 2.2rem);\n  font-weight: 900;\n  line-height: 1.1;\n  letter-spacing: 0.01em;\n  text-shadow: 0 2px 10px rgba(4, 16, 33, 0.55);\n}\n\n.dashboard-container.dashboard-redesign .featured-home-brand {\n  margin: 6px 0 0;\n  font-family: 'Sora', sans-serif;\n  font-size: clamp(1.7rem, 4.8vw, 3.3rem);\n  font-weight: 900;\n  line-height: 1;\n  letter-spacing: 0.01em;\n  background: linear-gradient(135deg, #0c2240 0%, #0b4a86 48%, #118acb 100%);\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n}\n\n.dashboard-container.dashboard-redesign .featured-home-caption {\n  margin: 10px 0 0;\n  color: #eaf6ff;\n  font-size: clamp(0.92rem, 2.1vw, 1.18rem);\n  font-weight: 700;\n  letter-spacing: 0.01em;\n  text-shadow: 0 2px 10px rgba(4, 16, 33, 0.5);\n}\n\n@keyframes dash2-slide-in {\n  from {\n    opacity: 0.5;\n    transform: scale(0.985);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.dashboard-container.dashboard-redesign .featured-cta-wrap {\n  position: absolute;\n  left: 50%;\n  bottom: 30px;\n  transform: translateX(-50%);\n  z-index: 3;\n}\n\n@media (min-width: 1400px) {\n  .dashboard-container.dashboard-redesign .featured-slide {\n    min-height: 460px;\n    background-size: auto 100%;\n    background-repeat: repeat-x;\n    background-position: center;\n    background-color: #050a17;\n  }\n\n  .dashboard-container.dashboard-redesign .featured-cta-wrap {\n    bottom: 34px;\n  }\n}\n\n.dashboard-container.dashboard-redesign .featured-carousel-controls {\n  position: absolute;\n  right: 20px;\n  bottom: 18px;\n  z-index: 2;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.dashboard-container.dashboard-redesign .carousel-arrow {\n  width: 34px;\n  height: 34px;\n  border-radius: 999px;\n  border: 1px solid rgba(255, 255, 255, 0.25);\n  background: rgba(8, 13, 28, 0.56);\n  color: #fff;\n  font-size: 19px;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.dashboard-container.dashboard-redesign .carousel-dots {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 0 2px;\n}\n\n.dashboard-container.dashboard-redesign .carousel-dot {\n  width: 9px;\n  height: 9px;\n  border-radius: 999px;\n  border: none;\n  padding: 0;\n  background: rgba(255, 255, 255, 0.4);\n  cursor: pointer;\n  transition: transform 0.2s ease, background-color 0.2s ease;\n}\n\n.dashboard-container.dashboard-redesign .carousel-dot.active {\n  width: 24px;\n  background: #68deff;\n}\n\n.dashboard-container.dashboard-redesign .featured-slide-labels {\n  position: absolute;\n  left: 20px;\n  bottom: 18px;\n  z-index: 2;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.dashboard-container.dashboard-redesign .slide-label {\n  border: 1px solid rgba(255, 255, 255, 0.24);\n  border-radius: 999px;\n  background: rgba(8, 13, 28, 0.45);\n  color: #c8d3f3;\n  padding: 6px 12px;\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  cursor: pointer;\n}\n\n.dashboard-container.dashboard-redesign .slide-label.active {\n  color: #07162f;\n  background: #68deff;\n  border-color: #68deff;\n}\n\n.dashboard-container.dashboard-redesign .game-icon-large {\n  font-size: 52px;\n  line-height: 1;\n}\n\n.dashboard-container.dashboard-redesign .game-title {\n  margin: 12px 0 0;\n  font-family: 'Sora', sans-serif;\n  font-size: clamp(2rem, 4vw, 2.8rem);\n  line-height: 1.05;\n}\n\n.dashboard-container.dashboard-redesign .game-subtitle {\n  margin: 8px 0 14px;\n  color: #a6b5e4;\n  font-size: 1rem;\n  letter-spacing: 0.02em;\n}\n\n.dashboard-container.dashboard-redesign .game-description {\n  margin: 0;\n  color: #d8e1ff;\n  max-width: 66ch;\n}\n\n.dashboard-container.dashboard-redesign .game-stats {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 10px;\n  margin: 20px 0 24px;\n}\n\n.dashboard-container.dashboard-redesign .game-stats .stat-item {\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  background: rgba(255, 255, 255, 0.04);\n  border-radius: 12px;\n  padding: 10px 12px;\n}\n\n.dashboard-container.dashboard-redesign .game-stats .stat-label {\n  display: block;\n  font-size: 11px;\n  color: #93a5dd;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n}\n\n.dashboard-container.dashboard-redesign .game-stats .stat-value {\n  display: block;\n  margin-top: 6px;\n  font-size: 15px;\n  font-weight: 800;\n  color: #fff;\n}\n\n.dashboard-container.dashboard-redesign .btn-play-now {\n  border: none;\n  background: linear-gradient(140deg, #00ccff, #4f93ff);\n  color: #04162f;\n  font-weight: 800;\n  border-radius: 14px;\n  padding: 12px 20px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  transition: 0.2s ease;\n}\n\n.dashboard-container.dashboard-redesign .btn-play-now:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 12px 26px rgba(0, 204, 255, 0.36);\n}\n\n.dashboard-container.dashboard-redesign .game-visual {\n  min-height: 250px;\n  border-radius: 22px;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  background: linear-gradient(150deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.04));\n  position: relative;\n  display: grid;\n  place-items: center;\n  overflow: hidden;\n}\n\n.dashboard-container.dashboard-redesign .visual-effect {\n  position: absolute;\n  inset: -20%;\n  background: conic-gradient(from 180deg, rgba(255, 255, 255, 0.12), transparent 36%, rgba(255, 255, 255, 0.15), transparent 70%);\n  animation: dash2-spin 9s linear infinite;\n}\n\n@keyframes dash2-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.dashboard-container.dashboard-redesign .card-stack {\n  position: relative;\n  z-index: 1;\n}\n\n.dashboard-container.dashboard-redesign .whot-card {\n  width: 74px;\n  height: 98px;\n  border-radius: 12px;\n  background: #fff;\n  color: #101623;\n  display: grid;\n  place-items: center;\n  font-size: 34px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.35);\n}\n\n.dashboard-container.dashboard-redesign .card-1 { transform: rotate(-14deg) translate(-36px, 18px); }\n.dashboard-container.dashboard-redesign .card-2 { transform: rotate(0deg); }\n.dashboard-container.dashboard-redesign .card-3 { transform: rotate(14deg) translate(36px, 18px); }\n\n.dashboard-container.dashboard-redesign .chess-board-preview {\n  display: flex;\n  gap: 16px;\n}\n\n.dashboard-container.dashboard-redesign .chess-piece {\n  width: 62px;\n  height: 62px;\n  border-radius: 16px;\n  display: grid;\n  place-items: center;\n  font-size: 38px;\n  background: rgba(255, 255, 255, 0.2);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n.dashboard-container.dashboard-redesign .flappy-preview .bird {\n  font-size: 48px;\n  text-align: center;\n  margin-bottom: 16px;\n}\n\n.dashboard-container.dashboard-redesign .pipes {\n  display: flex;\n  gap: 22px;\n}\n\n.dashboard-container.dashboard-redesign .pipe {\n  width: 20px;\n  height: 96px;\n  border-radius: 999px;\n  background: linear-gradient(180deg, #4fffc6, #13be8e);\n}\n\n.dashboard-container.dashboard-redesign .stats-bar {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.dashboard-container.dashboard-redesign .stat-card {\n  border-radius: 16px;\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  padding: 12px 14px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.dashboard-container.dashboard-redesign .stat-icon {\n  font-size: 20px;\n}\n\n.dashboard-container.dashboard-redesign .stat-info {\n  display: grid;\n  gap: 2px;\n}\n\n.dashboard-container.dashboard-redesign .stat-info .stat-label {\n  font-size: 12px;\n  color: #9eb0e8;\n}\n\n.dashboard-container.dashboard-redesign .stat-info .stat-value {\n  font-size: 15px;\n  font-weight: 700;\n  color: #fff;\n}\n\n.dashboard-container.dashboard-redesign .game-modes-section,\n.dashboard-container.dashboard-redesign .daily-section,\n.dashboard-container.dashboard-redesign .quick-links-section,\n.dashboard-container.dashboard-redesign .matchmaking-section,\n.dashboard-container.dashboard-redesign .guest-section,\n.dashboard-container.dashboard-redesign .referral-section,\n.dashboard-container.dashboard-redesign .support-section {\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 22px;\n  background: rgba(10, 15, 30, 0.75);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  padding: 24px;\n}\n\n.dashboard-container.dashboard-redesign .section-header {\n  margin-bottom: 14px;\n}\n\n.dashboard-container.dashboard-redesign .section-title {\n  margin: 0;\n  font-family: 'Sora', sans-serif;\n  font-size: clamp(1.25rem, 2.5vw, 1.7rem);\n}\n\n.dashboard-container.dashboard-redesign .section-subtitle {\n  margin: 6px 0 0;\n  color: #a5b3df;\n}\n\n.dashboard-container.dashboard-redesign .game-modes-grid {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.dashboard-container.dashboard-redesign .game-mode-card {\n  position: relative;\n  border-radius: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  background: rgba(255, 255, 255, 0.05);\n  color: #eff3ff;\n  text-align: left;\n  padding: 14px;\n  cursor: pointer;\n  transition: 0.2s ease;\n}\n\n.dashboard-container.dashboard-redesign .game-mode-card:hover {\n  transform: translateY(-2px);\n  border-color: rgba(79, 147, 255, 0.75);\n}\n\n.dashboard-container.dashboard-redesign .featured-mode {\n  border-color: rgba(160, 124, 255, 0.7);\n  background: linear-gradient(160deg, rgba(126, 99, 255, 0.2), rgba(255, 255, 255, 0.05));\n}\n\n.dashboard-container.dashboard-redesign .mode-icon-wrapper {\n  width: 42px;\n  height: 42px;\n  border-radius: 12px;\n  display: grid;\n  place-items: center;\n  margin-bottom: 10px;\n  background: linear-gradient(135deg, #38456f, #29355c);\n}\n\n.dashboard-container.dashboard-redesign .from-purple-500.to-pink-500 { background: linear-gradient(135deg, #8c56ff, #ff5ec8); }\n.dashboard-container.dashboard-redesign .from-red-500.to-orange-500 { background: linear-gradient(135deg, #ff4f61, #ff8a42); }\n.dashboard-container.dashboard-redesign .from-green-500.to-teal-500 { background: linear-gradient(135deg, #10c67b, #00b3aa); }\n.dashboard-container.dashboard-redesign .from-blue-500.to-cyan-500 { background: linear-gradient(135deg, #4f93ff, #00ccff); }\n.dashboard-container.dashboard-redesign .from-yellow-500.to-red-500 { background: linear-gradient(135deg, #ffd24f, #ff6c50); }\n\n.dashboard-container.dashboard-redesign .mode-title {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 700;\n}\n\n.dashboard-container.dashboard-redesign .mode-description {\n  margin: 6px 0 0;\n  color: #a9b7e2;\n  font-size: 0.9rem;\n}\n\n.dashboard-container.dashboard-redesign .mode-play-btn {\n  margin-top: 10px;\n  font-size: 0.85rem;\n  color: #75d9ff;\n  font-weight: 700;\n}\n\n.dashboard-container.dashboard-redesign .mode-badge {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  min-width: 26px;\n  height: 22px;\n  padding: 0 8px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 800;\n  display: grid;\n  place-items: center;\n}\n\n.dashboard-container.dashboard-redesign .hot-badge {\n  background: #ff4d73;\n  color: #fff;\n}\n\n.dashboard-container.dashboard-redesign .pending-badge {\n  background: #00d2ff;\n  color: #04213b;\n}\n\n.dashboard-container.dashboard-redesign .daily-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.dashboard-container.dashboard-redesign .daily-card {\n  border-radius: 14px;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  background: rgba(255, 255, 255, 0.05);\n  padding: 14px;\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  gap: 10px;\n  align-items: center;\n}\n\n.dashboard-container.dashboard-redesign .daily-icon {\n  font-size: 24px;\n}\n\n.dashboard-container.dashboard-redesign .daily-game {\n  margin: 0;\n  font-size: 1rem;\n}\n\n.dashboard-container.dashboard-redesign .daily-challenge {\n  margin: 4px 0 0;\n  color: #9fb0e3;\n  font-size: 0.9rem;\n}\n\n.dashboard-container.dashboard-redesign .daily-reward {\n  border-radius: 999px;\n  background: rgba(0, 210, 255, 0.16);\n  border: 1px solid rgba(0, 210, 255, 0.45);\n  color: #9cecff;\n  padding: 6px 10px;\n  font-weight: 700;\n  font-size: 0.85rem;\n}\n\n.dashboard-container.dashboard-redesign .daily-card.coming-soon .daily-reward {\n  background: rgba(255, 255, 255, 0.08);\n  border-color: rgba(255, 255, 255, 0.22);\n  color: #d8e1ff;\n}\n\n.dashboard-container.dashboard-redesign .daily-card--referral {\n  border-color: rgba(0, 210, 120, 0.35);\n  background: rgba(0, 210, 120, 0.07);\n}\n\n.dashboard-container.dashboard-redesign .daily-card--referral .daily-reward {\n  background: rgba(0, 210, 120, 0.18);\n  border-color: rgba(0, 210, 120, 0.55);\n  color: #7dffc7;\n}\n\n.dashboard-container.dashboard-redesign .daily-referral-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 8px;\n  flex-wrap: wrap;\n}\n\n.dashboard-container.dashboard-redesign .daily-ref-code {\n  font-family: monospace;\n  font-size: 0.82rem;\n  color: #7dffc7;\n  background: rgba(0, 210, 120, 0.12);\n  border: 1px solid rgba(0, 210, 120, 0.3);\n  border-radius: 6px;\n  padding: 2px 8px;\n  letter-spacing: 1px;\n}\n\n.dashboard-container.dashboard-redesign .daily-ref-copy {\n  background: rgba(0, 210, 120, 0.2);\n  border: 1px solid rgba(0, 210, 120, 0.5);\n  color: #7dffc7;\n  border-radius: 6px;\n  padding: 3px 12px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.dashboard-container.dashboard-redesign .daily-ref-copy:hover {\n  background: rgba(0, 210, 120, 0.35);\n}\n\n.dashboard-container.dashboard-redesign .quick-links-grid {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.dashboard-container.dashboard-redesign .quick-link-card {\n  border-radius: 14px;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  background: rgba(255, 255, 255, 0.05);\n  color: #fff;\n  text-align: left;\n  padding: 14px;\n  cursor: pointer;\n  transition: 0.2s ease;\n}\n\n.dashboard-container.dashboard-redesign .quick-link-card:hover {\n  transform: translateY(-2px);\n  border-color: rgba(79, 147, 255, 0.7);\n}\n\n.dashboard-container.dashboard-redesign .quick-icon {\n  display: block;\n  font-size: 20px;\n  margin-bottom: 6px;\n}\n\n.dashboard-container.dashboard-redesign .quick-label {\n  display: block;\n  font-weight: 700;\n}\n\n.dashboard-container.dashboard-redesign .quick-desc {\n  display: block;\n  margin-top: 3px;\n  font-size: 0.85rem;\n  color: #a2b2df;\n}\n\n.dashboard-container.dashboard-redesign .active-challenge-card {\n  border-radius: 14px;\n  border: 1px solid rgba(0, 210, 255, 0.38);\n  background: rgba(0, 210, 255, 0.1);\n  padding: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 10px;\n}\n\n.dashboard-container.dashboard-redesign .active-challenge-card--whot {\n  border-color: rgba(250, 204, 21, 0.42);\n  background:\n    linear-gradient(135deg, rgba(250, 204, 21, 0.14), rgba(245, 158, 11, 0.08)),\n    rgba(255, 255, 255, 0.06);\n}\n\n.dashboard-container.dashboard-redesign .challenge-info {\n  display: grid;\n  gap: 3px;\n}\n\n.dashboard-container.dashboard-redesign .challenge-info span {\n  color: #bed0ff;\n  font-size: 0.9rem;\n}\n\n.dashboard-container.dashboard-redesign .btn-resume,\n.dashboard-container.dashboard-redesign .btn-find-match,\n.dashboard-container.dashboard-redesign .btn-leave-queue,\n.dashboard-container.dashboard-redesign .btn-guest,\n.dashboard-container.dashboard-redesign .btn-login,\n.dashboard-container.dashboard-redesign .btn-copy,\n.dashboard-container.dashboard-redesign .btn-share {\n  border: none;\n  border-radius: 12px;\n  padding: 10px 14px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: 0.2s ease;\n}\n\n.dashboard-container.dashboard-redesign .btn-resume,\n.dashboard-container.dashboard-redesign .btn-find-match,\n.dashboard-container.dashboard-redesign .btn-guest,\n.dashboard-container.dashboard-redesign .btn-copy {\n  background: linear-gradient(140deg, #4f93ff, #00ccff);\n  color: #061d3a;\n}\n\n.dashboard-container.dashboard-redesign .btn-leave-queue {\n  background: linear-gradient(140deg, #ff5d79, #ff7a50);\n  color: #fff;\n}\n\n.dashboard-container.dashboard-redesign .btn-login,\n.dashboard-container.dashboard-redesign .btn-share {\n  background: rgba(255, 255, 255, 0.12);\n  color: #eef3ff;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.dashboard-container.dashboard-redesign .btn-resume:hover,\n.dashboard-container.dashboard-redesign .btn-find-match:hover,\n.dashboard-container.dashboard-redesign .btn-leave-queue:hover,\n.dashboard-container.dashboard-redesign .btn-guest:hover,\n.dashboard-container.dashboard-redesign .btn-login:hover,\n.dashboard-container.dashboard-redesign .btn-copy:hover,\n.dashboard-container.dashboard-redesign .btn-share:hover {\n  transform: translateY(-1px);\n}\n\n.dashboard-container.dashboard-redesign .error-message,\n.dashboard-container.dashboard-redesign .queue-status,\n.dashboard-container.dashboard-redesign .referral-feedback {\n  border-radius: 10px;\n  padding: 10px 12px;\n  font-size: 0.92rem;\n  margin-bottom: 10px;\n}\n\n.dashboard-container.dashboard-redesign .error-message {\n  background: rgba(255, 87, 120, 0.14);\n  border: 1px solid rgba(255, 87, 120, 0.45);\n  color: #ffc3d0;\n}\n\n.dashboard-container.dashboard-redesign .queue-status,\n.dashboard-container.dashboard-redesign .referral-feedback {\n  background: rgba(255, 255, 255, 0.08);\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  color: #d9e5ff;\n}\n\n.dashboard-container.dashboard-redesign .matchmaking-controls {\n  display: grid;\n  gap: 12px;\n}\n\n.dashboard-container.dashboard-redesign .wager-label,\n.dashboard-container.dashboard-redesign .balance-hint {\n  color: #a6b5e4;\n}\n\n.dashboard-container.dashboard-redesign .wager-value-display {\n  margin: 6px 0;\n  font-size: 1.5rem;\n  font-weight: 800;\n}\n\n.dashboard-container.dashboard-redesign .wager-slider {\n  width: 100%;\n}\n\n.dashboard-container.dashboard-redesign .guest-card {\n  border-radius: 14px;\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  background: rgba(255, 255, 255, 0.05);\n  padding: 18px;\n}\n\n.dashboard-container.dashboard-redesign .guest-card h3 {\n  margin: 0;\n}\n\n.dashboard-container.dashboard-redesign .guest-card p {\n  margin: 8px 0 14px;\n  color: #afbee9;\n}\n\n.dashboard-container.dashboard-redesign .guest-buttons {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.dashboard-container.dashboard-redesign .referral-content {\n  display: grid;\n  grid-template-columns: 0.9fr 1.1fr;\n  gap: 12px;\n}\n\n.dashboard-container.dashboard-redesign .referral-code-card,\n.dashboard-container.dashboard-redesign .referral-link-card {\n  border-radius: 14px;\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  background: rgba(255, 255, 255, 0.05);\n  padding: 14px;\n  display: grid;\n  gap: 8px;\n}\n\n.dashboard-container.dashboard-redesign .code-label,\n.dashboard-container.dashboard-redesign .link-label {\n  color: #9fb0e3;\n  font-size: 0.85rem;\n}\n\n.dashboard-container.dashboard-redesign .code-value,\n.dashboard-container.dashboard-redesign .link-value {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace;\n  padding: 8px 10px;\n  border-radius: 10px;\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  background: rgba(255, 255, 255, 0.06);\n  word-break: break-all;\n}\n\n.dashboard-container.dashboard-redesign .link-actions {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.dashboard-container.dashboard-redesign .support-callout {\n  border-radius: 14px;\n  border: 1px solid rgba(0, 210, 255, 0.3);\n  background: rgba(0, 210, 255, 0.09);\n  color: #d9f7ff;\n  padding: 12px 14px;\n  margin-bottom: 14px;\n}\n\n.dashboard-container.dashboard-redesign .support-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.dashboard-container.dashboard-redesign .support-card {\n  border-radius: 14px;\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  background: rgba(255, 255, 255, 0.05);\n  padding: 16px;\n  display: grid;\n  gap: 8px;\n  color: #eef3ff;\n  text-decoration: none;\n  transition: transform 0.2s ease, border-color 0.2s ease, background-color 0.2s ease;\n}\n\n.dashboard-container.dashboard-redesign .support-card:hover {\n  transform: translateY(-2px);\n  border-color: rgba(79, 147, 255, 0.75);\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.dashboard-container.dashboard-redesign .support-label {\n  color: #9fb0e3;\n  font-size: 0.85rem;\n}\n\n.dashboard-container.dashboard-redesign .support-value {\n  font-size: 1rem;\n  word-break: break-word;\n}\n\n.dashboard-container.dashboard-redesign .support-hint {\n  color: #bfd0ff;\n  font-size: 0.9rem;\n  line-height: 1.45;\n}\n\n.dashboard-container.dashboard-redesign .menu-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(5, 8, 16, 0.65);\n  z-index: 1000;\n}\n\n.dashboard-container.dashboard-redesign .profile-menu-modal {\n  position: fixed;\n  top: 84px;\n  right: 24px;\n  width: min(360px, calc(100vw - 30px));\n  border-radius: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.16);\n  background: rgba(10, 15, 30, 0.95);\n  box-shadow: 0 26px 46px rgba(0, 0, 0, 0.55);\n  padding: 16px;\n  z-index: 1001;\n}\n\n.dashboard-container.dashboard-redesign .profile-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 12px;\n}\n\n.dashboard-container.dashboard-redesign .profile-avatar {\n  width: 42px;\n  height: 42px;\n  border-radius: 999px;\n  display: grid;\n  place-items: center;\n  font-weight: 800;\n  background: linear-gradient(140deg, #7e63ff, #00ccff);\n  color: #061d3a;\n}\n\n.dashboard-container.dashboard-redesign .profile-name {\n  margin: 0;\n}\n\n.dashboard-container.dashboard-redesign .profile-stats {\n  display: grid;\n  gap: 8px;\n}\n\n.dashboard-container.dashboard-redesign .profile-stat {\n  border-radius: 10px;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  background: rgba(255, 255, 255, 0.05);\n  padding: 9px 10px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n@media (max-width: 1150px) {\n  .dashboard-container.dashboard-redesign .featured-cta-wrap {\n    bottom: 44px;\n  }\n\n  .dashboard-container.dashboard-redesign .stats-bar,\n  .dashboard-container.dashboard-redesign .game-modes-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .dashboard-container.dashboard-redesign .daily-grid,\n  .dashboard-container.dashboard-redesign .quick-links-grid,\n  .dashboard-container.dashboard-redesign .referral-content,\n  .dashboard-container.dashboard-redesign .support-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 760px) {\n  .dashboard-container.dashboard-redesign .dashboard-inner {\n    width: calc(100vw - 12px);\n    max-width: calc(100vw - 12px);\n    margin: 0 auto;\n    padding: 14px 12px 16px;\n  }\n\n  .dashboard-container.dashboard-redesign .dashboard-content {\n    width: 100%;\n    min-width: 0;\n    justify-items: stretch;\n    gap: 18px;\n  }\n\n  .dashboard-container.dashboard-redesign .dashboard-content > * {\n    width: 100%;\n    min-width: 0;\n  }\n\n  .dashboard-container.dashboard-redesign .hero-glass-card,\n  .dashboard-container.dashboard-redesign .game-modes-section,\n  .dashboard-container.dashboard-redesign .daily-section,\n  .dashboard-container.dashboard-redesign .quick-links-section,\n  .dashboard-container.dashboard-redesign .matchmaking-section,\n  .dashboard-container.dashboard-redesign .guest-section,\n  .dashboard-container.dashboard-redesign .referral-section,\n  .dashboard-container.dashboard-redesign .support-section {\n    padding: 16px;\n    border-radius: 16px;\n  }\n\n  .dashboard-container.dashboard-redesign .featured-slide {\n    min-height: 430px;\n    padding: 20px;\n  }\n\n  .dashboard-container.dashboard-redesign .featured-home-copy {\n    display: block;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    width: calc(100% - 40px);\n    padding: 13px 12px;\n    border-radius: 14px;\n  }\n\n  .dashboard-container.dashboard-redesign .featured-cta-wrap {\n    bottom: 72px;\n  }\n\n  .dashboard-container.dashboard-redesign .featured-slide-labels {\n    left: 14px;\n    bottom: 14px;\n    gap: 6px;\n  }\n\n  .dashboard-container.dashboard-redesign .slide-label {\n    padding: 5px 10px;\n    font-size: 11px;\n  }\n\n  .dashboard-container.dashboard-redesign .featured-carousel-controls {\n    right: 14px;\n    bottom: 14px;\n  }\n\n  .dashboard-container.dashboard-redesign .game-stats {\n    grid-template-columns: 1fr;\n  }\n\n  .dashboard-container.dashboard-redesign .stats-bar,\n  .dashboard-container.dashboard-redesign .game-modes-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .dashboard-container.dashboard-redesign .daily-card {\n    grid-template-columns: auto 1fr;\n  }\n\n  .dashboard-container.dashboard-redesign .daily-reward {\n    grid-column: span 2;\n    justify-self: start;\n  }\n\n  .dashboard-container.dashboard-redesign .profile-menu-modal {\n    right: 12px;\n    left: 12px;\n    width: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
